<template>
  <page-wrapper title="ส่วนลดบ้าน SC" ref="pageEl">
    <div class="page-container row" ref="page-container">

      <div class="report-filter col-12">
        <div class="form">
        
          <div class="section">
            <div>
              <div class="label">วันที่แลก Voucher</div>
              <date-picker v-model="redeemedDateRange" :disabled="!isDropdownDisabled" type="daterange"></date-picker>
            </div>
            <div>
              <div class="label">วันที่ใช้ Voucher</div>
              <date-picker v-model="usedDateRange" :disabled="!isDropdownDisabled" type="daterange"></date-picker>
            </div>
          </div>

          <div class="section">
            <div>
              <div class="label">วันที่ปิดโอน</div>
              <date-picker v-model="transferDateRange" :disabled="!isDropdownDisabled" type="daterange"></date-picker>
            </div>
            <div>
              <div class="label">วันที่มีการถอยปิดโอน</div>
              <date-picker v-model="rollbackDateRange" :disabled="!isDropdownDisabled" type="daterange"></date-picker>
            </div>
          </div>

          <div class="section" col="3">
            <div>
              <div class="label">สถานะของ Voucher </div>
              <el-select v-model="selectedVoucherStatus" :disabled="!isDropdownDisabled" style="width: 100%;" clearable>
                <el-option v-for="(t, idx) in filterVoucherStatus" :key="idx" :label="t.label" :value="t.value"></el-option>
              </el-select>
            </div>
            <div>
              <div class="label">
                Cost Center (ontop)
              </div>
              <SelectUniqueCostCenter
                v-model="selectedCostCenter"
                :is-disabled="isDropdownDisabled"
              />
            </div>
            <div>
              <div class="label">Transaction Type</div>
              <el-select v-model="selectedTransactionType" :disabled="!isDropdownDisabled" style="width: 100%" clearable>
                <el-option v-for="(t, idx) in filterTransactionType" :key="idx" :label="t.label" :value="t.value"></el-option>
              </el-select>
            </div>
          </div>

          <div style="
            display: flex;
            justify-content: center;
          ">

            <el-button
              type="primary"
              :disabled="
                !isSearchDisabled
              "
              @click="
                handleSearch
              ">
              ค้นหา
            </el-button>
            
            <el-button
              type="info"
              :disabled="
                !isClickDownloadAsCSVDisabled
              "
              @click.prevent="
                downloadFileReport
              ">
              ดาวน์โหลด
            </el-button>

            <el-button 
              plain
              type="danger"
              :disabled="
                !isClearDisabled
              "
              @click="
                handleClickClear
              ">
              รีเซ็ต
            </el-button>

          </div>

        </div>

      </div>

      <div class="report-content col-12">

        <div
          v-show="latest_update_time != null"
          class="report-header">
          <div >
            <b>รายงานอัปเดต</b>
            <p>
              {{ latest_update_message }}
            </p>
          </div>
          <div>
            <div>
              {{ totalCount }}
            </div>
            <div align="right">
              <el-button
                v-for="
                  i in [10, 20, 30]
                "
                :key="i"
                circle
                size="small"
                :type="
                  limit == i ? 'primary' : ''
                "
                @click="
                  limit = i
                ">
                {{ i }}
              </el-button>
            </div>
          </div>
        </div>

        <!-- Data Table -->
        <div>
          <DataTable
            :data="reports"
            :headers="headers"
            :loading="tableLoading">
          </DataTable>
        </div>

        <div style="text-align: center;">
          <el-pagination
            background
            layout="
              prev, pager, next
            "
            :total="total"
            :disabled="
              !isPaginationDisable
            "
            :current-page="page"
            :page-size="limit"
            @current-change="
              handleCurrentChange
            ">
          </el-pagination>
        </div>
      </div>
      
    </div>
  </page-wrapper>
</template>

<script>
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import DatePicker from "@/lib/components/DatePicker";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { formatOrFallbackToInput } from "@/lib/dateTime";
import DataTable from '@/lib/components/DataTable'
import SelectUniqueCostCenter from '../components/SelectUniqueCostCenter.vue'

import {
  formatTotalPagination,
  stringsToDates,
  datesToStrings
} from '../../../lib/util'

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
    DataTable,
    SelectUniqueCostCenter
  },
  data() {
    // Select option parameter
    const filterVoucherType = [
      { label: "ทั้งหมด", value: undefined },
      { label: "ซื้อของบน RJ Store", value: "RJ_STORE" },
      { label: "แลกบัตรกำนัล Partner", value: "PARTNER" },
    ];
    const filterCostCenter = [
      { label: "ทั้งหมด", value: undefined },
    ]
    const filterVoucherStatus = [
      { label: "ทั้งหมด", value: undefined },
      { label: "Redeemed (แลก Voucher)", value: "REDEEMED" },
      { label: "Used (ใช้ Voucher)", value: "USED" },
      { label: "Completed (ปิดโอนบ้านที่ใช้ Voucher)", value: "COMPLETED" },
      { label: "Expired (Voucher หมดอายุ)", value: "EXPIRED" }
    ]
    const filterTransactionType = [
      { label: "ทั้งหมด", value: undefined },
      { label: "ปิดโอน", value: "TRANSFER" },
      { label: "ถอยปิดโอน", value: "ROLLBACK" },
    ]

    //  Header for table
    const headers = [
      {
        label: "Voucher Code",
        value: "voucher_code"
      },
      {
        label: "สถานะของ Voucher",
        value: "voucher_status"
      },
      {
        label: "วันที่แลก Voucher",
        value: "voucher_redeemed_at"
      },
      {
        label: "วันที่ใช้ Voucher",
        value: "voucher_used_at"
      },
      {
        label: 'วันที่ Voucher หมดอายุ',
        value: 'item_expired_at'
      },
      {
        label: "วันที่ปิดโอน",
        value: "transfer_date"
      },
      {
        label: "วันที่ถอยปิดโอน",
        value: "rollback_date"
      },
      {
        label: "Transaction Type",
        value: "transaction_type"
      },
      {
        label: "จำนวน MNC ที่ใช้แลก (MNC)",
        value: "coin_amount_used"
      },
      {
        label: "มูลค่า MNC บาท",
        value: 'coin_to_baht'
      },
      {
        label: "ส่วนลด(บาท)",
        value: "discount_price"
      },
      {
        label: 'UserID',
        value: 'used_user_id'
      },
      {
        label: "บริษัท (รหัส)",
        value: "company_code"
      },
      {
        label: "โครงการ",
        value: "project_code"
      },
      {
        label: "Unit",
        value: "unit"
      },
      {
        label: "บ้านเลขที่",
        value: "address_no"
      },
      {
        label: "Cost center(On top)",
        value: "item_cost_center"
      },
      {
        label: "Price(On top)",
        value: "item_price"
      }
    ]

    // Group parameter
    const filterInput = {
      filterCostCenter,
      filterVoucherStatus,
      filterVoucherType,
      filterTransactionType
    }
    const selectedInput = {
      redeemedDateRange: [],
      usedDateRange: [],
      transferDateRange: [],
      rollbackDateRange: [],
      selectedCostCenter: undefined,
      selectedVoucherStatus: undefined,
      selectedTransactionType: undefined
    }
    const inputCondition = {
      isDropdownDisabled: true,
      isSearchDisabled: true,
      isClickDownloadWithIncentiveAsCSVDisabled: true,
      isClickDownloadAsCSVDisabled: true,
      isClearDisabled: true,
      isPaginationDisable: true,
    }
    const pagination = {
      page: 1,
      limit: 10,
      total: 0,
      latest_update_time: "",
    }

    // Define page parameter
    return {
      ...inputCondition,
      ...filterInput,
      ...selectedInput,
      ...pagination,
      reports: [],
      headers,
      reportType: 'home-discount',
      tableLoading: false
    };
  },
  created() {
    this.setupData();
  },
  watch: {
    async "$route.query"() {
      await this.setupData();
      this.$refs.pageEl.$el.querySelector(".page-container").scrollTop = 0;
    },
    async limit (from, to) {

      if (from != to) {
        await this.fetchReports()
      }
    }
  },
  computed: {
    totalCount() {
      // Get total report count for pagination
      return formatTotalPagination(
        this.reports.length,
        this.page,
        this.total,
        this.limit
      )
    },
    getQueryParams() {
      // Get parameter form router
      const {
        redeemedDateRange,
        usedDateRange,
        transferDateRange,
        rollbackDateRange,
        selectedCostCenter,
        selectedVoucherStatus,
        selectedTransactionType,
        page,
        limit
      } = this.$route.query;

      // Assign to parameter formatted
      return {
        redeemed_at: datesToStrings(redeemedDateRange),
        used_at: datesToStrings(usedDateRange),
        transfer_at: datesToStrings(transferDateRange),
        rollback_at: datesToStrings(rollbackDateRange),
        item_cost_center: selectedCostCenter,
        voucher_status: selectedVoucherStatus,
        transaction_type: selectedTransactionType,
        page: (page && +page) || 1,
        limit: limit || this.limit
      };
    },
    latest_update_message() {
      // Get message BO Report formate
      const format = "dd MMMM yyyy เวลา HH:mm น.";
      return this.formatDateToTH(this.latest_update_time, format);
    }
  },
  methods: {
    setupData() {
      // Load report
      this.queryBuilder();
      this.fetchReports();
    },
    queryBuilder() {
      // Get parameter form router
      const {
        item_cost_center,
        voucher_status,
        transaction_type,
        page,
        limit
      } = this.getQueryParams;

      // Get data from route parameter
      const {
        redeemedDateRange,
        usedDateRange,
        transferDateRange,
        rollbackDateRange,
      } = this.$route.query

      // Sync router parameter to filter input
      this.redeemedDateRange = stringsToDates(redeemedDateRange)
      this.usedDateRange = stringsToDates(usedDateRange)
      this.transferDateRange = stringsToDates(transferDateRange)
      this.rollbackDateRange = stringsToDates(rollbackDateRange)
      this.selectedCostCenter = item_cost_center
      this.selectedVoucherStatus = voucher_status
      this.selectedTransactionType = transaction_type
      this.page = page;
      this.limit = limit
    },
    handleSearch() {
      const {
        redeemedDateRange,
        usedDateRange,
        transferDateRange,
        rollbackDateRange,
        selectedCostCenter,
        selectedVoucherStatus,
        selectedTransactionType,
      } = this;

      // Sync router parameter by filter input value
      let query = {
        redeemedDateRange: datesToStrings(redeemedDateRange),
        usedDateRange: datesToStrings(usedDateRange),
        transferDateRange: datesToStrings(transferDateRange),
        rollbackDateRange: datesToStrings(rollbackDateRange),
        selectedCostCenter,
        selectedVoucherStatus,
        selectedTransactionType,
        page: 1
      };

      // Filter out null value
      query = Object.fromEntries(
        Object.entries(query).filter(([key, value]) => value)
      );

      // Replace route with query string
      const route = {
        name: this.$route.name,
        query: query
      };
      this.replaceRoute(route);
    },
    handleClickClear() {
      const route = {
        name: this.$route.name
      };
      this.replaceRoute(route);
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page: (page && +page) || 1 
        }
      };
      this.replaceRoute(route);
    },
    async fetchReports() {
      this.tableLoading = true

      // Get query parameters
      const query = this.getQueryParams;

      // Build client request
      await baanRueJaiClient.admin.redeem
        .getRedeemTransactionReport(query, this.reportType)
        .then(response => {
          // Get report result
          const result = response.data.result

          // Map result data
          this.reports = result.reports;
          this.total = result.total;
          this.latest_update_time = result.timestamp
            ? result.timestamp
            : null;
        })
        .catch(error => {
          const message = error.response
            ? error.response.data.message
            : error.message;
          alert(
            `ไม่สามารถดู Report ได้เนื่องจาก "${message || "ไม่พบข้อมูล"}"`
          );
          console.error(error);
        }).finally(() => {
          this.tableLoading = false
          // Allow button able click
          this.isAbleButton();
        });
    },
    async downloadFileReport(event) {
      // get date format 2023-11-06-161249
      const dateFilename = DateTime.utc()
        .setZone('Asia/Bangkok')
        .toFormat('yyyy-MM-dd-HHmmss')

      // Init file name for download report
      const fileName = `${dateFilename}-voucher-used-reports.xlsx`;
      event.preventDefault();
      this.isDisableButton();

      // Init request params
      const query = this.getQueryParams;
      delete query.page

      // Send request
      const response = await baanRueJaiClient.admin.redeem
        .downloadRedeemTransactionReport(query, this.reportType)

      // check response before download
      if (response.data) {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        link.remove();
      }
      this.isAbleButton();
    },
    isDisableButton() {
      this.isSearchDisabled = false;
      this.isClearDisabled = false;
      this.isClickDownloadAsCSVDisabled = false;
      this.isClickDownloadWithIncentiveAsCSVDisabled = false;
      this.isPaginationDisable = false;
      this.isDropdownDisabled = false;
    },
    isAbleButton() {
      this.isSearchDisabled = true;
      this.isClearDisabled = true;
      this.isClickDownloadAsCSVDisabled = true;
      this.isClickDownloadWithIncentiveAsCSVDisabled = true;
      this.isPaginationDisable = true;
      this.isDropdownDisabled = true;
    },
    formatDateToTH(date, format) {
      return formatOrFallbackToInput(date, format);
    },
    replaceRoute(route) {
      this.$router.replace({ ...route });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  padding: 15px;
}

.page-container {
  padding: 1rem;
  margin: 0;
}

.report-filter {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.report-filter .form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form .section {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
}

.form .section[col="3"] {
  grid-template-columns: repeat(3, 1fr);
}

.label {
  font-size: .9rem;
  margin-bottom: .25rem;
}

.report-content {
  display: flex;
  flex-direction: column;
  gap: 1rem; 
}

.report-content .report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-button.el-button--danger.is-plain:hover,
.el-button.el-button--danger.is-plain:focus {
  color: white !important;
}

@media screen and (max-width: 640px) {
  .form .section, 
  .form .section[col="3"] {
    grid-template-columns: 1fr;
  }

  .report-filter {
    margin-bottom: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/features/redeemed-mnc/pages/HomeDiscountVoucherReportPage.vue